import React, {useEffect} from "react";
import enlilImage from "../../assets/logo-5cd08655.svg";
import css_self from "./css/NavBar.module.scss";
import css_button from "../Common/css/CCButton.module.scss";
import "./css/NavBar.scss";
import {Avatar, Box, Button, IconButton, Menu, MenuItem, Popover, Typography} from "@mui/material";
import {Blue3, Grey2, Grey17, Grey6, White} from "../../theme/styles";
import {useNavigate} from "react-router-dom";
import {SyncAlt, HelpOutlineOutlined, Logout, Menu as MenuIcon, PermIdentity, Apps, Dashboard, Engineering, Settings, Google} from "@mui/icons-material";
import useAppContext from "../../util/AppContext";
import Login from "../Login/Login";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiamond} from "@fortawesome/free-solid-svg-icons";

type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement}

export default function NavBar() {
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = React.useState<boolean>(false);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const appContext = useAppContext();
    const [showGlobalMenu, setShowGlobalMenu] = React.useState<boolean>(false);

    const sessionUpdateListener = () => {
        // @ts-ignore
        let _showLoginDialog: boolean = appContext?.sessionContext.getShowLoginDialog();
        setShowGlobalMenu(appContext?.sessionContext?.getShowGlobalMenu()!);

        setShowLogin(_showLoginDialog);
    };

    useEffect(() => {
       // @ts-ignore
        EventBus.session.addListener("update", sessionUpdateListener);

       // @ts-ignore
        return () => {
            EventBus.session.removeListener("update", sessionUpdateListener);
        }
    }, []);

    let content = (
        <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingLeft: 20, paddingRight: 5, borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Grey2, backgroundColor: White}}>
                <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "50px"}}>
                    {appContext?.sessionContext?.valid() ? (
                        <div style={{marginTop: "8px", marginLeft: "-7px", marginRight: "15px"}}>
                            <IconButton className={!showGlobalMenu ? css_button.blueIconButton3 : css_button.blueIconButton4} onClick={() => {
                                if (appContext?.sessionContext?.valid()) {
                                    appContext?.sessionContext?.setShowGlobalMenu(!showGlobalMenu)
                                    setShowGlobalMenu(!showGlobalMenu);
                                }
                            }}>
                                <MenuIcon sx={{width: 25, height: 25}}/>
                            </IconButton>
                        </div>
                    ) : null}
                    <div key={1} style={{paddingTop: "0px", paddingRight: "2px", marginLeft: "-5px"}}><img className={css_self.EnlilLogo} src={enlilImage} alt="Home"/></div>
                    <div key={2} style={{paddingTop: "5px", marginLeft: "65px", marginRight: "4px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>|</Typography></div>
                    <div key={3} style={{paddingTop: "7px", marginLeft: "3px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>Jobs</Typography></div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", flexGrow: 1, height: "40px", paddingTop: "6px", marginLeft: "30px"}}>
                </div>
                <div key={2} style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", height: "40px", minWidth: "260px", marginLeft: "30px", paddingTop: "3px"}}>
                    <div style={{width: "40px", paddingLeft: "5px", paddingTop: "1px", height: "40px"}}>{renderAccountNavigation()}</div>
                </div>
                {appContext?.sessionContext?.valid() ? (
                    <div key={3} style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                        <div style={{width: "40px", paddingLeft: "5px", marginTop: "5px", height: "40px"}}>{renderAppsNavigation()}</div>
                    </div>
                ) : null}
            </div>
        </div>
    )

    return (
        <>{content}</>
    );

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    function renderAccountNavigation() {

        let accountMarkup = (
            <div>
                <IconButton className={css_self.NavMenuButton} onClick={() => {
                    if (appContext) { // @ts-ignore
                        appContext.sessionContext.setShowLoginDialog(true);
                    }
                    setShowLogin(true);
                }}>
                    <PermIdentity/>
                </IconButton>
            </div>
        )
        if (appContext?.sessionContext.valid()) {
            accountMarkup = (
                <Button className={css_self.NavMenuButton} variant="text" onClick={(e) => setMenu({id: "account", target: e.currentTarget})}>
                    <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 35, height: 35}}>{stringAvatar(appContext?.sessionContext.getName())}</Avatar>
                </Button>
            )
        }

        return (
            <div>
                {showLogin ? <Login/> : null}
                {accountMarkup}
                {menu?.id === "account" ? (
                    <Menu anchorEl={menu.target}
                          anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                          transformOrigin={{vertical: -10, horizontal: "center"}}
                          open={true}
                          onClose={() => setMenu(null)}
                          TransitionProps={{
                              onExited: () => setMenu(null),
                          }}
                          MenuListProps={{
                              ...{"data-cc-component": "NavMenu"},
                              disablePadding: true,
                              style: {"minWidth": "200px"},
                          }}
                          PaperProps={{
                              elevation: 2,
                          }}
                    >
                        <MenuItem key={"account"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Company: <b>{appContext?.sessionContext.getCompanyName()}</b></Typography>
                        </MenuItem>
                        <MenuItem key={"name"} disabled className={css_self.Standard}>
                            <Typography component="div" style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Hello, <b>{appContext?.sessionContext.getName()}</b></Typography>
                        </MenuItem>
                        <MenuItem divider key={"help"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/help");
                        }}>
                            <HelpOutlineOutlined style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Help</Typography>
                        </MenuItem>
                        <MenuItem divider key={"switchCompany"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                        }}>
                            <SyncAlt style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Switch Company</Typography>
                        </MenuItem>
                        <MenuItem divider key={"logout"} className={css_self.Standard} onClick={() => {
                            setMenu(null);
                            navigate("/logout");
                        }}>
                            <Logout style={{color: Grey6}} />
                            <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Log out</Typography>
                        </MenuItem>
                    </Menu>
                ) : null}
            </div>
        );
    }

    function renderAppsNavigation() {
    return (
        <div style={{marginRight: "10px", marginTop: "7px"}}>
            <IconButton className={css_buttons.blueIconButton} onClick={(e) => setMenu({id: "apps", target: e.currentTarget})}>
                <Apps/>
            </IconButton>
            {menu?.id === "apps" ? (
                <Popover anchorEl={menu.target}
                         anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                         transformOrigin={{vertical: -9, horizontal: "left"}}
                         open={menu !== null}
                         onClose={() => setMenu(null)}
                         TransitionProps={{
                             onExited: () => setMenu(null),
                         }}
                >
                    <Box sx={{p: 2, bgcolor: "background.paper", width: "450px", height: "265px"}}>
                        <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", height: "25px", backgroundColor: "#EDEFF3"}}>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#525968", textAlign: "center", paddingTop: "2px"}}>Enlil</Typography>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", marginTop: "5px"}}>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/dashboard");
                                        }}>
                                        <Dashboard sx={{color: "#1498D8", width: 45, height: 45}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Dashboard</Typography>
                                </div>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/jobs");
                                        }}>
                                        <Settings sx={{color: "#1498D8", width: 45, height: 45}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Jobs</Typography>
                                </div>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/executions");
                                        }}>
                                        <Engineering sx={{color: "#1498D8", width: 45, height: 45}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Executions</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", height: "25px", backgroundColor: "#EDEFF3", marginTop: "10px"}}>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#525968", textAlign: "center", paddingTop: "2px"}}>Data Sources</Typography>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", marginTop: "5px"}}>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/google");
                                        }}>
                                        <Google sx={{color: "#1498D8", width: 45, height: 45}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Google</Typography>
                                </div>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/google");
                                        }}>
                                        <FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "35px", height: "35px", marginTop: "2px"}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Dropbox</Typography>
                                </div>
                                <div style={{width: "100px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                    <IconButton className={css_self.AppMenuButton}
                                        onClick={() => {
                                            setMenu(null);
                                            navigate("/google");
                                        }}>
                                        <FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "35px", height: "35px", marginTop: "2px"}}/>
                                    </IconButton>
                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>S3</Typography>
                                </div>
                            </div>
                        </div>
                    </Box>
                </Popover>
            ) : null}
        </div>
    );
}

}
